import { Label, Typography } from 'fronton-react';
import React from 'react';
import { getLang } from 'utils';
import { DurationOfUseType } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { reviewAdditionalInfoWrapper } from './review.styles';
import { getDate } from './utils';

type Props = {
  isVerified?: boolean;
  date?: Date;
  durationOfUse?: DurationOfUseType | string;
} & React.HTMLAttributes<HTMLElement>;

export const ReviewAdditionalInfo: React.FC<Props> = ({ date, isVerified, durationOfUse, ...htmlProps }) => {
  const { t } = useTranslation();
  const lang = useSelector(getLang);

  return (
    <div className={reviewAdditionalInfoWrapper} {...htmlProps}>
      {isVerified && <Label background="accent-light">{t('reviews.review.confirmed-purchase')}</Label>}
      {date && (
        <Typography variant="caption" color="text-minor">
          {getDate(date, lang)}
        </Typography>
      )}
      {durationOfUse && (
        <Typography variant="caption" color="text-minor">
          {durationOfUse}
        </Typography>
      )}
    </div>
  );
};
